// create a new pseudo guid string
export function newGuid()
{
	  function s4()
	  {
	    return Math.floor((1 + Math.random()) * 0x10000)
	      .toString(16)
	      .substring(1);
	  }
	  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}
// determine if o is an empty object
export function isEmptyObj(o)
{
	return o && o.constructor === Object && Object.keys(o).length === 0;
}

// determine if s if an empty string when trimmed, also returns true if s is not a string at all or null or undefined
export function isEmptyStr(s)
{
	return !isString(s) || !s || !s.trim();
}

// perform a case insensitive string comparison on two values
export function streq(a, b)
{
	return String(a).toUpperCase() === String(b).toUpperCase();
}
// determine if the given value is an object (NOT an array and NOT null) - it might still be for example Math
export function isObject(v)
{
	return v && v.constructor === Object;
}

// determine if the given value is an integer
export function isInt(v)
{
	return v !== null && v !== undefined && v.constructor === Number && (v % 1) === 0;
}

// determine if the given value is a number (not infinite, not NaN)
export function isNumber(v)
{
	return typeof v === 'number' && !isNaN(v) && isFinite(v);
}

var numRegex = /^[-+]?(?:\d*\.\d+|\d+(?:\.\d*)?)$/; // 1  1.  1.2  .2 (and everything with optional + or - in front)

// determine if the given value (string or number) represents a valid number (non infinite, not NaN), no spaces allowed
export function isNumeric(v)
{
	return (isNumber(v) || isString(v)) && numRegex.test(v);
}

// determine if the given value is a string (not null, but may be empty)
export function isString(v)
{
	return typeof v === 'string';
}

// determine if the given value is a boolean value
export function isBoolean(v)
{
	return typeof v === 'boolean';
}

// determin if the given value is a date object
export function isDate(v)
{
	return v && v.constructor === Date;
}

// determine if the given value has a simple type
export function isSimpleType(v)
{
	return v === null || v === undefined || isString(v) || isBoolean(v) || isNumber(v);
}

// note that we allow any UUID that conforms to the syntactical format, we don't validate variant and version bits, this test also passes for the nil UUID
var uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// determine if the given value is a Guid string (without curly braces, with dashes, case doesn't matter though)
// DON'T ever intend to allow curly braces here, it will break API calls!
export function isGuid(v)
{
	return  v && v.constructor === String && uuidRegex.test(v);
}
